<div class="general-container">
    <div class="general-container__toolbar">
        <app-toolbar></app-toolbar>
    </div>
    <div class="general-container__body">
        <app-sidenav></app-sidenav>        
    </div>
    
</div>